module.exports = __webpack_public_path__ + "static/media/clear-icon-dark.5fa50249.png";